import i18n from 'i18next';

import { IncomeFrequencyEnum } from '../enums/IncomeFrequencyEnum';
import { IncomeFrequencyOption } from '../types/IncomeFrequencyOption';

export const incomeFrequencyOptions: IncomeFrequencyOption[] = [
  {
    name: i18n.t('incomeFrequency.annually'),
    value: IncomeFrequencyEnum.ANNUALLY,
  },
  {
    name: i18n.t('incomeFrequency.monthly'),
    value: IncomeFrequencyEnum.MONTHLY,
  },
  {
    name: i18n.t('incomeFrequency.semiMonthly'),
    value: IncomeFrequencyEnum.SEMI_MONTHLY,
  },
  {
    name: i18n.t('incomeFrequency.biWeekly'),
    value: IncomeFrequencyEnum.BI_WEEKLY,
  },
  {
    name: i18n.t('incomeFrequency.weekly'),
    value: IncomeFrequencyEnum.WEEKLY,
  },
];
